// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2hlUw","signatureBlock":"Footer_signatureBlock__2ofUC","signature":"Footer_signature__2DnuK"};